<style lang="scss">
.el-range-separator {
  width: 30% !important;
  line-height: 1.7 !important;
}
</style>
<template>
  <div>
    <SpFinder
      ref="finder"
      title="招新统计"
      :show-tool-bar="false"
      :hooks="{
        beforeSearch: beforeSearch
      }"
      :setting="setting"
      :url="{
        data: requestUrl
      }"
      :columns="columns"
      :reserve-selection="true"
      row-key="id"
      :no-selection="noSelection"
      @reset="onFinderReset"
    >
      <template v-slot:dateSearch>
        <el-date-picker
          v-model="params.dateValue"
          type="daterange"
          range-separator="至"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          @change="dateChange"
        />
      </template>
      <template v-slot:guide>
        <el-button @click="handleShowGuidePicker">
          <!-- 添加导购以筛选 -->
          添加导购以筛选{{
            callData.userList.length > 0 ? `（${callData.userList.length}个导购）` : ''
          }}
        </el-button>
      </template>
      <template v-slot:guide2>
        <div />
      </template>
      <template v-slot:sex="{ value }">
        <el-input v-model="value.sex" />
      </template>
    </SpFinder>
    <SpGuideBox
v-model="showGuidePicker"
:call-data="callData"
@getUserList="onChangeGuide"
/>

    <!-- 导出报表对话框 -->
    <SpExportList
      v-model="exportDialogVisible"
      :show-store-select="true"
      :files-type="10"
      list-type="salesperson"
      include-current-date
      :show-sales-person-status="showSalesPersonStatus"
    />
  </div>
</template>

<script>
import mixin from './mixin'
import { createSetting } from '@shopex/finder'
import moment from 'moment'

export default {
  mixins: [mixin],

  data () {
    const columns = [
      {
        name: '员工姓名', // 表头
        key: 'salesperson_name' // 匹配data key
      },
      {
        name: '员工工号', // 表头
        key: 'employee_number' // 匹配data key
      },
      {
        name: '员工门店', // 表头
        key: 'store_name' // 匹配data key
      },
      {
        name: '门店编号', // 表头
        key: 'store_bn' // 匹配data key
      },
      {
        name: '新增客户数', // 表头
        key: 'total_newuser_num' // 匹配data key
      },
      {
        name: '绑定客户数', // 表头
        key: 'total_binduser_num' // 匹配data key
      },
      {
        name: '客户删除数', // 表头
        key: 'total_userdel_num' // 匹配data key
      }
    ]

    return {
      setting: createSetting({
        search: [
          { key: 'dateSearch', name: '', slot: 'dateSearch' },
          { key: 'guide', name: '', slot: 'guide' },
          { key: 'guide2', name: '', slot: 'guide2' }
        ],
        actions: [
          {
            name: '导出报表',
            key: 'create', // 用于指定key,必填
            slot: 'header',
            type: 'button',
            buttonType: 'primary',
            action: {
              type: 'dialog',
              title: '订单导出',
              handler: (row) => {
                this.exportDialogVisible = true
              }
            }
          }
        ]
      }),
      selectFile: 'employee_numbers',
      requestUrl: process.env.VUE_APP_BASE_API + '/members/every-salesperson-count',
      columns,
      employeeInfo: [
        { value: 'employee_numbers', label: '导购工号' },
        { value: 'employee_name', label: '导购姓名' },
        { value: 'mobile', label: '手机号' }
      ],
      storeNum: null,
      pickerOptions: {
        disabledDate (date) {
          return date.getTime() > Date.now()
        }
      },
      detailList: [], //明细列表数据
      params: {
        keywords: '',
        dateValue: []
      },
      listType: 'salesperson',
      exportDialogVisible: false, //导出对话框展示与否
      storeVisible: false, //选择门店展示
      selectStoreData: [], //选择门店数据
      communityVisible: false, //选择社群展示
      selectCommunityData: [], //选择社群数据,
      showSalesPersonStatus: true,
      showGuidePicker: false,
      callData: {
        storeList: [],
        userList: []
      },
      noSelection: true
    }
  },
  methods: {
    beforeSearch (params) {
      const selectFile = this.selectFile
      params[selectFile] = this.params.keywords
      params['store_id'] = this.params.store_id
      params['start_date'] = this.params.start_date
      params['end_date'] = this.params.end_date
      if (this.callData && this.callData.userList) {
        params['salesperson_id'] = this.callData.userList
          .map((item) => item.salesperson_id)
          .join(',')
      }
      return params
    },
    onFinderReset () {
      this.selectStoreData = []
      this.selectFile = 'employee_numbers'
      this.storeNum = ''
      this.params = {}
      this.callData = {
        storeList: [],
        userList: []
      }
    },
    handleShowGuidePicker () {
      this.showGuidePicker = true
    },
    onChangeGuide (data) {
      console.log('onChangeGuide:', data)
      const { storeList, userList } = data
      this.callData = {
        storeList: storeList,
        userList: userList
      }
    },
    goExportList () {
      this.$router.push({
        path: '/staffManagement/exportList?filestype=22',
        replace: true
      })
    }
  }
}
</script>
